export default __webpack_public_path__ + "static/media/email@2x.67daf973.png";